import classNames from 'classnames'
import React from 'react'

type PropTypes = {
  className?: string
  children: React.ReactNode
  onClick?: () => void
}

const Row = ({ className, children, onClick }: PropTypes) => {
  return (
    // Fixes issues with creating a table with rounded corners and border-separate.
    // Was a better idea than wrapping it in a div with rounded corners and overflow-hidden
    <tr
      onClick={onClick}
      className={classNames('group [&>td]:first-of-type:border-t [&>td]:first-of-type:border-t-gray-400 [&:not(:last-of-type)>td]:border-b [&:last-of-type)>td]:pb-4 [&:last-of-type)>td]:pb-4 [&>td:first-of-type]:last-of-type:rounded-bl-[5px] [&>td:last-of-type]:last-of-type:rounded-br-[5px] [&:not(:last-of-type)>td]:border-b-gray-400 bg-white', {
        'cursor-pointer group/callback': onClick !== undefined,
        className,
      })}
    >
      {children}
    </tr>
  )
}

export default Row
